import Vue from 'vue'

Vue.filter('cnpj', function (cnpj) {
  return (cnpj + '').replace(/[^a-zA-Z0-9]/g, '')
    //   /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/
    .replace(/([a-zA-Z0-9]{2})([a-zA-Z0-9]{3})([a-zA-Z0-9]{3})([a-zA-Z0-9]{4})(\d{2})/, '$1.$2.$3/$4-$5')
})

Vue.filter('phone', function (phone) {
  if (phone && phone.length === 10) {
    return phone > 0 ? (phone + '').replace(/[^0-9]/g, '')
      .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3') : ''
  }
  return phone > 0 ? (phone + '').replace(/[^0-9]/g, '')
    .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3') : ''
})

Vue.filter('cpf', function (cpf) {
  return (cpf + '').replace(/[^0-9]/g, '')
    //   /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/
    .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
})

Vue.filter('thousandMask', function (value, precision) {
  let valueArray = (value + '').split(',')
  let number = valueArray[0]
  // let precision = 2
  precision = isNaN(precision = Math.abs(precision)) ? 2 : precision
  let precisionSeparator = ','
  let decimalSeparator = '.'
  let negative = number < 0 ? '-' : ''
  let i = parseInt(number = Math.abs(+number || 0)) + ''

  // Serve para que se não for um multiplo de 3 a primeira separação das casas decimais sejam adicionadas, por exemplo: 1.000 e 10.000.
  let j = 0
  j = (j = i.length) > 3 ? j % 3 : 0

  return negative + //
    (j ? i.substr(0, j) + decimalSeparator : '') + // Efetiva a pontuação de não multiplos de 3
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + decimalSeparator) + // Adiciona o separador de 3 em 3 numeros
    (precision && valueArray.length > 1 ? precisionSeparator + valueArray[1] : '') // Obter a precisão
})
